import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from '@tanstack/react-router';

import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

import messages from './messages';

export type WeekplanView = 'weekplan' | 'overview';

type Props = {
  activeView: WeekplanView;
  year: number;
  week: number;
};

export const WeekplanViewSwitcher = ({ activeView, year, week }: Props) => {
  const navigate = useNavigate();

  const handleChange = (
    _: React.MouseEvent<HTMLElement>,
    newView: WeekplanView | null
  ) => {
    if (!newView || newView === activeView) return;
    if (newView === 'overview') {
      navigate({
        to: '/weekplan/$year/$week/overview',
        params: { year: year.toString(), week: week.toString() },
        search: { highlightPublisher: undefined, sidebarView: undefined },
      });
      return;
    }
    navigate({
      to: '/weekplan/$year/$week/$day/{-$shiftId}',
      params: {
        year: year.toString(),
        week: week.toString(),
        day: moment().weekday().toString(),
      },
    });
  };

  return (
    <ToggleButtonGroup
      value={activeView}
      exclusive
      onChange={handleChange}
      size="small"
      color="primary"
    >
      <ToggleButton value="weekplan">
        <FormattedMessage {...messages.weekplan} />
      </ToggleButton>
      <ToggleButton value="overview">
        <FormattedMessage {...messages.overview} />
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

export default WeekplanViewSwitcher;
